import { fetchAuthSession } from "aws-amplify/auth";
import { createContext, type ReactNode, useContext, useMemo } from "react";
import {
  apiUrl,
  DEV_AUTH,
  DEV_USER_EMAIL,
  DEV_USER_SUB,
} from "@/lib/auth/config";
import { type ApiClient, type AuthStrategy, createApiClient } from "./client";

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const client = useMemo(
    () =>
      createApiClient({
        baseUrl: apiUrl(),
        getAuth: async (): Promise<AuthStrategy> => {
          if (DEV_AUTH)
            return {
              kind: "dev-headers",
              sub: DEV_USER_SUB,
              email: DEV_USER_EMAIL,
            };
          try {
            const session = await fetchAuthSession();
            const token = session.tokens?.idToken?.toString();
            return token ? { kind: "bearer", token } : null;
          } catch {
            return null;
          }
        },
      }),
    [],
  );
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const c = useContext(ApiContext);
  if (!c) throw new Error("useApi() outside <ApiProvider>");
  return c;
}
